export const SIDEBAR_CLICK = "SIDEBAR_CLICK";
export const CART_CLICK = "CART_CLICK";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const SET_SINGLE_PRODUCT = "SET_SINGLE";
export const ADD_TO_CART = "ADD_TO_CART";
export const SET_TOTAL = "SET_TOTAL";
export const SYNC_STORAGE = "SYNC_STORAGE";
export const GET_STORAGE_CART = "GET_STORAGE_CART";
export const GET_STORAGE_PRODUCT = "GET_STORAGE_PRODUCT";
export const CLEAR_CART = "CLEAR_CART";
export const DECREMENT = "DECREMENT";
export const INCREMENT = "INCREMENT";
export const REMOVE = "REMOVE";
export const FILTER_PRODUCTS = "FILTER_PRODUCTS";
export const SORT_DATA = "SORT_DATA";
